import React from 'react'
import TopBar from './top-bar'
import Navbar from './navbar'
import Script from 'next/script'

export default function Header() {

  return (
    <div>
      <TopBar />
      <Navbar />
    </div>
  )
}
